import { Suspense, type ReactNode } from 'react';

import { PageLoader } from '@/shared/ui';
import { Header } from '@/components/base/Header';
import { DesktopSidebar } from '@/components/base/desktop/desktopHeader/DesktopSidebar';
import { CreateTaskAction } from './CreateTaskAction';
import { MobileNavigation } from './MobileNavigation';

type AppLayoutProps = {
  children: ReactNode;
};

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="flex min-h-screen bg-background">
      <DesktopSidebar />
      <div className="flex min-w-0 flex-1 flex-col lg:pr-6">
        <Header />
        <main className="container mx-auto flex-1 pb-6">
          <Suspense fallback={<PageLoader />}>{children}</Suspense>
        </main>
      </div>
      <MobileNavigation />
      <CreateTaskAction />
    </div>
  );
}
